__turbopack_context__.v({
  "boxBorderAnimation": "styles-module-scss-module__T81zyW__boxBorderAnimation",
  "dragContent": "styles-module-scss-module__T81zyW__dragContent",
  "dragToText": "styles-module-scss-module__T81zyW__dragToText",
  "error": "styles-module-scss-module__T81zyW__error",
  "fileInput": "styles-module-scss-module__T81zyW__fileInput",
  "illustration": "styles-module-scss-module__T81zyW__illustration",
  "underline": "styles-module-scss-module__T81zyW__underline",
  "uploadButton": "styles-module-scss-module__T81zyW__uploadButton",
  "uploadField": "styles-module-scss-module__T81zyW__uploadField",
  "uploadFieldWrapper": "styles-module-scss-module__T81zyW__uploadFieldWrapper",
});
